import type { CrmMessages } from "./englishCrmMessages";

// Plural forms follow ra-language-russian: "1 |||| 2-4 |||| 5+".
export const russianCrmMessages: CrmMessages = {
  resources: {
    companies: {
      name: "Компания |||| Компании |||| Компаний",
      forcedCaseName: "Компания",
      fields: {
        name: "Название компании",
        website: "Сайт",
        linkedin_url: "Ссылка на LinkedIn",
        phone_number: "Телефон",
        created_at: "Создана",
        nb_contacts: "Контактов",
        revenue: "Выручка",
        sector: "Отрасль",
        size: "Размер",
        tax_identifier: "ИНН",
        address: "Адрес",
        city: "Город",
        zipcode: "Индекс",
        state_abbr: "Регион",
        country: "Страна",
        description: "Комментарий",
        context_links: "Полезные ссылки",
        sales_id: "Ответственный",
      },
      empty: {
        description: "Пока в списке нет ни одной компании.",
        title: "Компаний нет",
      },
      import: {
        title: "Импорт компаний",
      },
      field_categories: {
        contact: "Контакт",
        additional_info: "Дополнительно",
        address: "Адрес",
        context: "Контекст",
      },
      action: {
        create: "Создать компанию",
        edit: "Изменить компанию",
        new: "Новая компания",
        show: "Открыть компанию",
      },
      added_on: "Добавлена %{date}",
      followed_by: "Ведёт %{name}",
      followed_by_you: "Ведёте вы",
      no_contacts: "Нет контактов",
      nb_contacts:
        "%{smart_count} контакт |||| %{smart_count} контакта |||| %{smart_count} контактов",
      nb_deals:
        "%{smart_count} сделка |||| %{smart_count} сделки |||| %{smart_count} сделок",
      sizes: {
        one_employee: "1 сотрудник",
        two_to_nine_employees: "2–9 сотрудников",
        ten_to_forty_nine_employees: "10–49 сотрудников",
        fifty_to_two_hundred_forty_nine_employees: "50–249 сотрудников",
        two_hundred_fifty_or_more_employees: "250 и более сотрудников",
      },
      autocomplete: {
        create_error: "Не удалось создать компанию",
        create_item: "Создать «%{item}»",
        create_label: "Начните вводить, чтобы создать новую компанию",
      },
    },
    contacts: {
      name: "Контакт |||| Контакты |||| Контактов",
      forcedCaseName: "Контакт",
      field_categories: {
        background_info: "О человеке",
        identity: "Имя",
        misc: "Прочее",
        personal_info: "Связь",
        position: "Должность",
      },
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        last_seen: "Последний контакт",
        title: "Должность",
        company_id: "Компания",
        email_jsonb: "Электронная почта",
        email: "Почта",
        phone_jsonb: "Телефоны",
        phone_number: "Телефон",
        linkedin_url: "Ссылка на LinkedIn",
        background: "Комментарий",
        has_newsletter: "Получает рассылку",
        sales_id: "Ответственный",
      },
      action: {
        add: "Добавить контакт",
        add_first: "Добавьте первый контакт",
        create: "Создать контакт",
        edit: "Изменить контакт",
        export_vcard: "Экспорт в vCard",
        new: "Новый контакт",
        show: "Открыть контакт",
      },
      autocomplete: {
        create_item: "Создать «%{item}»",
        create_label: "Начните вводить, чтобы создать новый контакт",
      },
      background: {
        last_activity_on: "Последняя активность: %{date}",
        added_on: "Добавлен %{date}",
        followed_by: "Ведёт %{name}",
        followed_by_you: "Ведёте вы",
        status_none: "Нет",
      },
      position_at: "%{title},",
      position_at_company: "%{title}, %{company}",
      empty: {
        description: "Пока в списке нет ни одного контакта.",
        title: "Контактов нет",
      },
      import: {
        title: "Импорт контактов",
      },
      inputs: {
        genders: {
          male: "Он",
          female: "Она",
          nonbinary: "Они",
        },
        personal_info_types: {
          work: "Рабочий",
          home: "Личный",
          other: "Другой",
        },
      },
      list: {
        error_loading: "Не удалось загрузить контакты",
      },
      show: {
        error_loading: "Не удалось загрузить контакт",
      },
      bulk_tag: {
        action: "Метка",
        back: "К меткам",
        create_description:
          "Создайте новую метку и примените её к выбранным контактам.",
        description:
          "Выберите существующую метку или создайте новую для выбранных контактов.",
        empty: "Меток пока нет. Создайте метку для выбранных контактов.",
        error: "Не удалось добавить метку контактам",
        removed:
          "Метка снята с %{smart_count} контакта |||| Метка снята с %{smart_count} контактов |||| Метка снята с %{smart_count} контактов",
        success:
          "Метка добавлена %{smart_count} контакту |||| Метка добавлена %{smart_count} контактам |||| Метка добавлена %{smart_count} контактам",
        title: "Добавить метку контактам",
      },
      merge: {
        action: "Объединить с другим контактом",
        confirm: "Объединить контакты",
        current_contact: "Текущий контакт (будет удалён)",
        description: "Объедините этот контакт с другим.",
        error: "Не удалось объединить контакты",
        merging: "Объединяем…",
        no_additional_data: "Нет данных для объединения",
        select_target: "Выберите контакт, с которым объединить",
        success: "Контакты объединены",
        target_contact: "Итоговый контакт (останется)",
        title: "Объединение контактов",
        warning_description:
          "Все данные будут перенесены во второй контакт. Отменить это действие нельзя.",
        warning_title: "Внимание: необратимое действие",
        what_will_be_merged: "Что будет объединено:",
      },
      filters: {
        before_last_month: "До прошлого месяца",
        before_this_month: "До начала месяца",
        before_this_week: "До начала недели",
        managed_by_me: "Мои контакты",
        search: "Имя, компания…",
        this_week: "На этой неделе",
        today: "Сегодня",
        tags: "Метки",
        tasks: "Задачи",
      },
      hot: {
        empty_change_status:
          "Чтобы изменить статус контакта, добавьте к нему заметку и нажмите «Параметры».",
        empty_hint: "Здесь появятся контакты со статусом «Горячий».",
        title: "Горячие контакты",
      },
    },
    leads: {
      name: "Лид |||| Лида |||| Лидов",
      forcedCaseName: "Лид",
      fields: {
        name: "Имя",
        phone: "Телефон",
        email: "Почта",
        company_name: "Компания",
        comment: "Комментарий",
        source: "Источник",
        stage_id: "Стадия",
        project_id: "Проект",
        sales_id: "Ответственный",
        contact_id: "Контакт",
        created_at: "Пришёл",
      },
      action: {
        new: "Новый лид",
        create: "Новый лид",
        back: "К лиду",
      },
      updated: "Лид сохранён",
    },
    deals: {
      name: "Сделка |||| Сделки |||| Сделок",
      forcedCaseName: "Сделка",
      fields: {
        name: "Название",
        description: "Описание",
        company_id: "Компания",
        contact_ids: "Контакты",
        categories: "Категории",
        amount: "Сумма",
        expected_closing_date: "Ожидаемая дата закрытия",
        stage: "Стадия",
        sales_id: "Ответственный",
        project_id: "Проект",
        pipeline_id: "Воронка",
        stage_id: "Стадия",
      },
      action: {
        back_to_deal: "Назад к сделке",
        create: "Создать сделку",
        new: "Новая сделка",
      },
      field_categories: {
        misc: "Прочее",
      },
      filters: {
        only_mine: "Только мои сделки",
      },
      archived: {
        action: "В архив",
        error: "Ошибка: сделка не заархивирована",
        list_title: "Архив сделок",
        success: "Сделка в архиве",
        title: "Сделка в архиве",
        view: "Открыть архив сделок",
      },
      inputs: {
        linked_to: "Связана с",
      },
      unarchived: {
        action: "Вернуть на доску",
        error: "Ошибка: сделка не возвращена из архива",
        success: "Сделка возвращена из архива",
      },
      updated: "Сделка обновлена",
      empty: {
        before_create: "прежде чем создавать сделку.",
        description: "Пока в списке нет ни одной сделки.",
        title: "Сделок нет",
      },
      import: {
        title: "Импорт сделок",
      },
      invalid_date: "Неверная дата",
    },
    notes: {
      name: "Заметка |||| Заметки |||| Заметок",
      forcedCaseName: "Заметка",
      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Файлы",
        contact_id: "Контакт",
        deal_id: "Сделка",
      },
      action: {
        add: "Добавить заметку",
        add_first: "Добавьте первую заметку",
        delete: "Удалить заметку",
        edit: "Изменить заметку",
        update: "Сохранить заметку",
        add_this: "Добавить заметку",
      },
      sheet: {
        create: "Новая заметка",
        create_for: "Новая заметка: %{name}",
        edit: "Изменить заметку",
        edit_for: "Изменить заметку: %{name}",
      },
      deleted: "Заметка удалена",
      empty: "Заметок пока нет",
      author_added: "%{name} добавил(а) заметку",
      you_added: "Вы добавили заметку",
      system_added: "1С",
      bitrix_added: "Битрикс24",
      me: "Я",
      list: {
        error_loading: "Не удалось загрузить заметки",
      },
      note_for_contact: "Заметка: %{name}",
      stepper: {
        hint: "Откройте карточку контакта и добавьте заметку",
      },
      added: "Заметка добавлена",
      inputs: {
        add_note: "Добавить заметку",
        options_hint: "(прикрепить файлы или изменить детали)",
        show_options: "Параметры",
      },
      actions: {
        attach_document: "Прикрепить файл",
      },
      validation: {
        note_or_attachment_required: "Нужна заметка или файл",
      },
    },
    sales: {
      name: "Сотрудник |||| Сотрудники |||| Сотрудников",
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Почта",
        secondary_email: "Дополнительная почта",
        secondary_emails: "Дополнительные адреса почты",
        administrator: "Администратор",
        disabled: "Отключён",
        password: "Пароль",
      },
      create: {
        error: "Не удалось создать сотрудника.",
        success: "Сотрудник создан.",
        title: "Новый сотрудник",
      },
      edit: {
        error: "Произошла ошибка. Попробуйте ещё раз.",
        record_not_found: "Запись не найдена",
        success: "Сотрудник обновлён",
        title: "Изменить: %{name}",
      },
      action: {
        new: "Новый сотрудник",
      },
    },
    tasks: {
      name: "Задача |||| Задачи |||| Задач",
      forcedCaseName: "Задача",
      fields: {
        text: "Описание",
        due_date: "Срок",
        type: "Тип",
        contact_id: "Контакт",
        due_short: "срок",
      },
      action: {
        add: "Добавить задачу",
        create: "Создать задачу",
        edit: "Изменить задачу",
      },
      actions: {
        postpone_next_week: "Перенести на следующую неделю",
        postpone_tomorrow: "Перенести на завтра",
        title: "действия с задачей",
      },
      added: "Задача добавлена",
      deleted: "Задача удалена",
      dialog: {
        create: "Новая задача",
        create_for: "Новая задача: %{name}",
      },
      sheet: {
        edit: "Изменить задачу",
        edit_for: "Изменить задачу: %{name}",
      },
      empty: "Задач пока нет",
      empty_list_hint: "Здесь появятся задачи, добавленные к контактам.",
      filters: {
        later: "Позже",
        overdue: "Просрочены",
        this_week: "На этой неделе",
        today: "Сегодня",
        tomorrow: "Завтра",
        with_pending: "С невыполненными задачами",
      },
      regarding_contact: "(по контакту %{name})",
      updated: "Задача обновлена",
    },
    tags: {
      name: "Метка |||| Метки |||| Меток",
      action: {
        add: "Добавить метку",
        create: "Создать метку",
      },
      dialog: {
        color: "Цвет",
        create_title: "Новая метка",
        edit_title: "Изменить метку",
        name_label: "Название метки",
        name_placeholder: "Введите название",
      },
      empty: "Меток пока нет.",
    },
  },
  crm: {
    action: {
      reset_password: "Сбросить пароль",
    },
    auth: {
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Повторите пароль",
      confirmation_required:
        "Перейдите по ссылке из письма, чтобы подтвердить учётную запись.",
      recovery_email_sent:
        "Если такой пользователь существует, вам скоро придёт письмо для восстановления пароля.",
      sign_in_failed: "Не удалось войти.",
      sign_in_google_workspace: "Войти через Google Workspace",
      signup: {
        create_account: "Создать учётную запись",
        create_first_user:
          "Создайте первую учётную запись, чтобы завершить настройку.",
        creating: "Создаём…",
        initial_user_created: "Первый пользователь создан",
      },
      welcome_title: "Добро пожаловать в «Всё видно»",
    },
    clients: {
      tabs_label: "Клиенты",
      people: "Люди",
      companies: "Компании",
    },
    projects: {
      confirm_delete_stage: "Удалить стадию «%{name}»?",
      confirm_delete_pipeline:
        "Удалить воронку «%{name}» вместе с её стадиями?",
      confirm_delete_hint:
        "Стадию, на которой есть записи, удалить нельзя: сначала перенесите их на другую стадию.",
      no_active_title: "Нет активных проектов",
      no_active_description:
        "Все проекты в архиве. Создайте проект или верните его из архива.",
      open_settings: "Настройки → Проекты",
      import_choose_project: "Импорт: выберите проект",
      outcome_label: "Итог",
      pipeline_name: "Название воронки",
      errors: {
        stage_exists: "В этой воронке уже есть стадия с таким названием",
        member_exists: "Этот сотрудник уже в проекте",
      },
      switcher: "Проект",
      all: "Все проекты",
      pipelines_label: "Воронки сделок",
      none_title: "Вас ещё не добавили в проект",
      none_description:
        "Собственник добавляет сотрудников в проекты: Настройки → Сотрудники.",
      title: "Проекты",
      general: "Общие",
      tabs_label: "Разделы настроек",
      new: "Новый проект",
      create: "Создать",
      name: "Название",
      color: "Цвет",
      archive: "В архив",
      unarchive: "Вернуть из архива",
      archived: "в архиве",
      lead_pipeline: "Лиды",
      add_pipeline: "Воронка сделок",
      new_pipeline_name: "Новая воронка",
      delete_pipeline: "Удалить воронку",
      stages: "Стадии",
      add_stage: "Добавить стадию",
      new_stage: "Новая стадия",
      stage_name: "Название стадии",
      drag: "Перетащите, чтобы поменять порядок",
      delete_stage: "Удалить стадию",
      lead_rules:
        "В воронке лидов одна стадия «выигрыш» (в сделку) и хотя бы одна «проигрыш».",
      members: "Участники",
      add_member: "Добавить сотрудника",
      no_members: "В проекте пока никого",
      remove_member: "Убрать",
      saved: "Сохранено",
      owner_sees_all: "Собственник видит всё",
      can_delete: "Может удалять",
      can_export: "Может выгружать",
      staff_title: "Сотрудники",
      new_employee: "Новый сотрудник",
      edit_employee: "Изменить",
      outcome: {
        open: "в работе",
        won: "выигрыш",
        lost: "проигрыш",
      },
      access: {
        label: "Доступ",
        none: "Нет доступа",
        own: "Только свои",
        department: "Свой отдел",
        all: "Всё по проекту",
      },
      roles: {
        owner: "Собственник",
        head: "Руководитель",
        manager: "Менеджер",
      },
    },
    leads: {
      sources: {
        call: "Звонок",
        site: "Сайт",
        avito: "Авито",
        drom: "Дром",
        email: "Почта",
        other: "Другое",
      },
      convert: "В сделку",
      open_deal: "Открыть сделку",
      converted: "Сделка создана",
      convert_error: "Не получилось создать сделку",
      no_responsible: "Без ответственного",
      only_mine: "Только мои лиды",
      view_label: "Вид",
      view_board: "Доска",
      view_list: "Список",
      list: "Лиды",
      empty: "Лидов пока нет",
      choose_project:
        "Доска видна для одного проекта: выберите его в шапке. Ниже лиды всех проектов списком.",
      won_hint: "Сюда лид попадает кнопкой «В сделку»",
      column_count:
        "%{smart_count} лид |||| %{smart_count} лида |||| %{smart_count} лидов",
    },
    connections: {
      title: "Подключения",
      is_set: "введён ✓",
      not_set: "не введён",
      save: "Сохранить",
      remove: "Удалить",
      saved: "Сохранено",
      removed: "Удалено",
      replace_placeholder: "Введите новое значение, чтобы заменить",
      generate: "Создать новый",
      generate_confirm: "Старый ключ перестанет работать. Создать новый?",
      generate_yes: "Да, создать",
      generated_once: "Скопируйте сейчас: больше этот ключ не покажем.",
      paste_own: "Или вставьте ключ из кабинета ВАТС",
      copy: "Копировать",
      copy_failed:
        "Не получилось скопировать. Выделите текст и скопируйте вручную",
      public_url: "Адрес CRM",
      public_url_hint:
        "Из него собираются ссылки в уведомлениях и адреса ниже. Например, https://crm.example.ru",
      public_url_bad: "Адрес должен начинаться с https:// или http://",
      mail: {
        title: "Почта компании",
        leads_from_unknown: "Заявки с незнакомых адресов создают лид",
        leads_from_unknown_hint:
          "Письмо с адреса, которого нет среди контактов, станет лидом. Пока выключено, CRM такие письма не забирает.",
        hint: "С этого ящика уходят письма сотрудников, у которых нет своего ящика. Ответы на них CRM забирает отсюда же.",
        people: "Личные ящики сотрудников",
        people_empty: "Своего ящика пока нет ни у кого",
        remove_person: "Удалить ящик сотрудника",
      },
      telegram: {
        title: "Телеграм",
        hint: "Сотрудники получают в Телеграм новые лиды, пропущенные звонки, передачу и стадии сделок, просроченные задачи.",
        steps:
          "1. Создайте бота у @BotFather (команда /newbot) и вставьте сюда его токен. 2. Каждый сотрудник в профиле вводит свой chat_id и нажимает «Проверить».",
        bot_token: "Токен бота",
        api_base: "Адрес прокси для Телеграма",
        api_base_hint:
          "Нужен, только если хостинг не открывает api.telegram.org. Обычно поле пустое.",
      },
      leads: {
        title: "Заявки с сайта и площадок",
        hint: "Форма сайта, Авито, Дром и другие сервисы присылают заявки на этот адрес (POST).",
        token: "Ключ для заявок",
        url_label: "Адрес для заявок",
        header_hint:
          "Ключ передаётся в адресе (?token=) или в заголовке X-Hook-Token.",
      },
      telephony: {
        title: "Телефония",
        provider: "АТС",
        provider_none: "Нет",
        provider_megafon: "МегаФон",
        lines: "Номера компании и проекты",
        lines_hint:
          "Звонок на номер из списка попадает в его проект. Остальные звонки идут в проект клиента или в основной.",
        number: "Номер",
        project: "Проект",
        add_line: "Добавить номер",
        remove_line: "Убрать номер",
        save: "Сохранить телефонию",
        saved: "Телефония сохранена",
        megafon_hint:
          "В кабинете ВАТС, раздел «Интеграция с CRM», укажите адрес ниже и ключ для запросов от ВАТС. Там же возьмите адрес API и ключ API.",
        megafon_url_label: "Адрес CRM для ВАТС",
        megafon_crm_token: "Ключ для запросов от ВАТС",
        megafon_api_url: "Адрес API ВАТС",
        megafon_api_key: "Ключ API ВАТС",
        own_title: "Своя АТС",
        own_hint:
          "Своя АТС присылает события звонков на этот адрес с заголовком X-Telephony-Token.",
        own_token: "Ключ для событий звонков",
        own_url_label: "Адрес для событий",
      },
      onec: {
        title: "1С",
        hint: "Заказы и оплаты из 1С видны в карточке сделки. CRM читает 1С каждые 30 минут и ничего в ней не меняет.",
        steps:
          "1. В 1С опубликуйте OData-интерфейс и создайте пользователя только с правом чтения. 2. Введите адрес, логин и пароль, включите сверку. 3. Менеджеры пишут номер сделки в комментарии заказа, например CRM-101.",
        enabled: "Сверка с 1С",
        odata_url: "Адрес OData",
        odata_url_hint:
          "Например, http://1c.example.ru/base/odata/standard.odata",
        bad_url: "Адрес должен начинаться с http:// или https://",
        key: "Как в 1С отмечают номер сделки",
        prefix: "Перед номером",
        number: "номер сделки",
        suffix: "После номера",
        suffix_placeholder: "можно пусто",
        example: "Пример:",
        key_hint:
          "Менеджер пишет это в номере или комментарии заказа. Второй заказ той же сделки: CRM-101-2. Число без этой приставки не связывается. Знак ␣ в примере означает пробел.",
        prefix_empty: "Укажите, что пишут перед номером, например CRM-",
        key_long: "До и после номера не больше 20 символов",
        prefix_bad: "Перед номером нужны буквы и без цифр, например CRM-",
        suffix_bad: "После номера без цифр",
        password_cleared:
          "Адрес 1С изменился, поэтому пароль 1С стёрт. Введите пароль 1С ещё раз",
        user: "Логин 1С",
        password: "Пароль 1С",
        save: "Сохранить 1С",
        saved: "Настройки 1С сохранены",
        check: "Проверить подключение",
        check_hint: "Проверяются сохранённые адрес, логин и пароль.",
        check_ok: "1С отвечает. Первый заказ: %{number} от %{date}",
        check_ok_empty: "1С отвечает. Заказов пока нет",
      },
    },
    telegram: {
      chat_id: "Телеграм chat_id",
      check: "Проверить",
      sent: "Сообщение отправлено, загляните в Телеграм",
      saved: "chat_id сохранён",
      hint: "Чтобы получать уведомления, найдите бота компании в Телеграме и нажмите «Старт» (/start). Свой chat_id пришлёт бот @userinfobot: напишите ему и скопируйте число Id.",
    },
    bitrix: {
      title: "Битрикс24",
      hint: "Клиенты, лиды, сделки, заметки и задачи из Битрикс24. CRM только читает Битрикс и ничего в нём не меняет.",
      steps:
        "1. В Битриксе откройте Разработчикам → Другое → Входящий вебхук, отметьте права crm, user и task и сохраните. 2. Вставьте адрес вебхука сюда. 3. Нажмите «Пробный перенос» и посмотрите итог. 4. Нажмите «Перенести» или включите синхронизацию.",
      webhook: "Адрес вебхука",
      webhook_hint:
        "Выглядит так: https://адрес-портала/rest/1/ключ/. После сохранения адрес не показывается.",
      mode: "Синхронизация с Битрикс24",
      mode_on:
        "Включена: каждые 10 минут CRM забирает изменения из Битрикса. Записи из Битрикса здесь только для чтения, их меняют в Битриксе. Свои заметки и задачи к ним добавлять можно.",
      mode_off:
        "Выключена: CRM ведётся здесь. Чтобы один раз перенести данные из Битрикса, нажмите «Перенести».",
      check: "Проверить",
      check_ok: "Битрикс24 отвечает. Вебхук создал пользователь %{name}",
      check_ok_empty: "Битрикс24 отвечает",
      dry_run: "Пробный перенос",
      run: "Перенести",
      run_hint:
        "Пробный перенос ничего не записывает и показывает, что будет создано. Повторный перенос обновит записи, дублей не будет.",
      no_webhook: "Сначала вставьте адрес вебхука и сохраните",
      run_confirm_title: "Перенести данные из Битрикс24?",
      run_confirm:
        "Это может занять несколько минут. Записи появятся в CRM, итог будет ниже.",
      dry_started: "Пробный перенос начался",
      started: "Перенос начался",
      running: {
        import: "Идёт перенос…",
        dry: "Идёт пробный перенос…",
        sync: "Идёт синхронизация…",
        starting: "Запускаем…",
      },
      last_pulled: "Последний перенос: %{time}",
      report_dry: "Пробный перенос %{time}: в CRM ничего не записано",
      report_import: "Итог переноса %{time}",
      report_sync: "Итог синхронизации %{time}",
      created: "создано",
      updated: "обновлено",
      skipped: "пропущено",
      entities: {
        projects: "Проекты",
        stages: "Стадии",
        companies: "Компании",
        contacts: "Контакты",
        leads: "Лиды",
        deals: "Сделки",
        notes: "Заметки",
        tasks: "Задачи",
      },
      archived: "Удалены в Битриксе, убраны в архив:",
      users_matched: "Сотрудники Битрикса, найденные здесь по почте: %{count}",
      users_unmatched:
        "Не нашли здесь по почте, их записи отданы собственнику:",
      lines: "Обратите внимание:",
      lines_all: "Показать все (%{count})",
      lines_less: "Свернуть",
      badge: "из Битрикса",
      badge_hint: "Запись из Битрикс24. Менять её можно в Битриксе",
    },
    onec: {
      title: "1С",
      order: "Заказ %{number} от %{date}",
      order_no_number: "Заказ от %{date}",
      amount: "Сумма",
      paid: "Оплачено",
      rest: "Остаток",
      progress: "Оплачено %{percent}%",
      synced: "Сверено с 1С %{time}",
      total: "Всего по заказам:",
      total_line: "оплачено %{paid} из %{amount}, остаток %{rest}",
      empty:
        "Заказа в 1С пока нет. Чтобы связать заказ, напишите в его комментарии %{key}",
      status: {
        unpaid: "Не оплачен",
        partial: "Оплачен частично",
        paid: "Оплачен",
      },
    },
    mail: {
      title: "Письма",
      write: "Написать письмо",
      empty: "Писем пока нет",
      only_latest:
        "Показано последнее %{smart_count} письмо |||| Показаны последние %{smart_count} письма |||| Показаны последние %{smart_count} писем",
      to: "Кому",
      cc: "Копия",
      to_hint: "Несколько адресов пишите через запятую",
      subject: "Тема",
      body: "Текст письма",
      template: "Шаблон",
      no_template: "Без шаблона",
      attach: "Прикрепить файл",
      attach_hint: "Не больше 20 МБ вместе",
      remove_file: "Убрать файл",
      send: "Отправить",
      sent: "Письмо отправлено",
      sent_except: "Письмо отправлено, кроме: %{list}",
      status_sent_except: "отправлено, кроме: %{list}",
      send_error: "Письмо не отправлено",
      upload_error: "Файл не загрузился",
      from: "От",
      no_subject: "(без темы)",
      show_images: "Показать картинки",
      images_blocked: "Картинки из интернета не загружены",
      as_text: "Текстом",
      as_html: "Как в письме",
      attachments: "Вложения",
      files_not_kept:
        "Файлы входящих писем CRM не сохраняет. Откройте их в почте.",
      status: {
        queued: "отправляется",
        sent: "отправлено",
        failed: "не отправлено",
        received: "получено",
      },
      direction: {
        in: "Входящее",
        out: "Исходящее",
      },
      mailbox: {
        title: "Почта",
        hint: "Письма из карточек уходят с вашего ящика, а ответы CRM забирает из него раз в 5 минут. Если своего ящика нет, письма уходят с ящика компании.",
        presets: "Заполнить для",
        from_addr: "Адрес почты",
        from_hint:
          "Тот же адрес, что и логин, или другой адрес на том же домене",
        from_name: "Имя отправителя",
        smtp_host: "Сервер SMTP",
        smtp_port: "Порт SMTP",
        imap_host: "Сервер IMAP",
        imap_port: "Порт IMAP",
        login: "Логин",
        login_hint:
          "Обычно это адрес почты. Если поле пустое, CRM возьмёт адрес почты.",
        password: "Пароль приложения",
        password_hint:
          "Для Яндекса, Mail.ru и Gmail создайте пароль приложения в настройках безопасности ящика. Обычный пароль от почты не подойдёт.",
        is_set: "введено",
        save: "Сохранить почту",
        saved: "Почта сохранена",
        nothing_typed: "Введите хотя бы одно поле",
        check: "Проверить",
        check_label: "Проверить почту",
        remove: "Удалить ящик",
        removed: "Ящик удалён",
        status_ok: "Отправка настроена",
        status_none: "Ящик не настроен",
        uses_company: "Письма уходят с ящика компании",
      },
    },
    mail_templates: {
      title: "Шаблоны писем",
      hint: "В тексте и теме можно писать {{клиент}}, {{сделка}}, {{сумма}} и {{менеджер}}. CRM заполнит их, когда сотрудник выберет шаблон в окне письма.",
      add: "Добавить шаблон",
      new_name: "Новый шаблон",
      name: "Название",
      subject: "Тема",
      body: "Текст",
      save: "Сохранить",
      saved: "Шаблон сохранён",
      delete: "Удалить",
      deleted: "Шаблон удалён",
      empty: "Шаблонов пока нет",
    },
    calls: {
      title: "Звонки",
      empty: "Звонков пока нет",
      call: "Позвонить",
      calling: "Звоним… возьмите трубку",
      call_error: "Не получилось позвонить",
      listen: "Слушать",
      nobody: "Сотрудник не определён",
      only_latest:
        "Показан последний %{smart_count} звонок |||| Показаны последние %{smart_count} звонка |||| Показаны последние %{smart_count} звонков",
      kind: {
        incoming: "Входящий",
        outgoing: "Исходящий",
        missed: "Пропущенный",
      },
      status: {
        in_progress: "идёт",
        success: "разговор",
        missed: "без ответа",
        busy: "занято",
        cancel: "сброшен",
      },
      ext_label: "Добавочный",
      ext_hint:
        "Добавочный номер или логин в АТС (для МегаФона это логин в ВАТС). По нему CRM видит, кто говорил, и звонит из карточки.",
      no_ext_hint:
        "Не указан, поэтому кнопки «Позвонить» нет. Добавочный задаёт собственник в Настройках → Сотрудники.",
      ext_saved: "Добавочный сохранён",
    },
    board: {
      stage_total: "Сумма по стадии «%{stage}»",
    },
    today: {
      title: "Сегодня",
      counter_overdue: "Просрочено",
      counter_today: "На сегодня",
      counter_stale: "Без движения",
      my_tasks: "Мои задачи на сегодня",
      no_tasks: "На сегодня задач нет",
      new_leads: "Новые лиды",
      stale_deals: "Сделки без движения 7 дней",
      no_stale_deals: "Все открытые сделки двигались на этой неделе",
      idle_days:
        "%{smart_count} день без движения |||| %{smart_count} дня без движения |||| %{smart_count} дней без движения",
      more: "и ещё %{smart_count}",
    },
    common: {
      more_fields: "Ещё",
      account_manager: "Ответственный",
      activity: "Активность",
      added: "добавлено",
      details: "Подробности",
      last_activity_with_date: "последняя активность: %{date}",
      load_more: "Показать ещё",
      misc: "Прочее",
      past: "Прошедшие",
      read_more: "Читать дальше",
      retry: "Повторить",
      show_less: "Свернуть",
      copied: "Скопировано",
      copy: "Копировать",
      loading: "Загрузка…",
      me: "Я",
      task_count:
        "%{smart_count} задача |||| %{smart_count} задачи |||| %{smart_count} задач",
    },
    changelog: {
      title: "Что нового",
    },
    activity: {
      added_company: "%{name} добавил(а) компанию",
      you_added_company: "Вы добавили компанию",
      added_contact: "%{name} добавил(а) контакт",
      you_added_contact: "Вы добавили контакт",
      added_note: "%{name} добавил(а) заметку о",
      you_added_note: "Вы добавили заметку о",
      added_note_about_deal: "%{name} добавил(а) заметку о сделке",
      you_added_note_about_deal: "Вы добавили заметку о сделке",
      added_deal: "%{name} добавил(а) сделку",
      you_added_deal: "Вы добавили сделку",
      at_company: "в",
      to: "для",
      load_more: "Показать ещё события",
    },
    dashboard: {
      deals_chart: "Ожидаемая выручка по сделкам",
      deals_pipeline: "Воронка сделок",
      latest_activity: "Последние события",
      latest_activity_error: "Не удалось загрузить последние события",
      latest_notes: "Мои последние заметки",
      latest_notes_added_ago: "добавлено %{timeAgo}",
      recent_contacts: "Недавно просмотренные",
      stepper: {
        install: "Установить «Всё видно»",
        progress: "%{step}/3 выполнено",
        whats_next: "Что дальше?",
      },
      upcoming_tasks: "Ближайшие задачи",
    },
    data_import: {
      button: "Импорт CSV",
      complete:
        "Импорт завершён. Загружено записей: %{importCount}, ошибок: %{errorCount}",
      csv_file: "Файл CSV",
      error:
        "Не удалось импортировать файл. Убедитесь, что это корректный CSV.",
      in_progress: "Идёт импорт…",
      progress:
        "Загружено %{importCount} из %{rowCount} записей, ошибок: %{errorCount}.",
      remaining_time: "Осталось примерно:",
      resource: "Раздел",
      sample_download: "Скачать образец CSV",
      sample_hint: "Образец файла CSV, который можно взять за основу",
      start: "Начать импорт",
      stop: "Остановить импорт",
      stopped:
        "Импорт остановлен. Загружено записей: %{importCount}, ошибок: %{errorCount}",
      title: "Импорт данных",
    },
    header: {
      import_data: "Импорт из JSON",
    },
    search: {
      title: "Поиск",
      placeholder:
        "Поиск по контактам, компаниям, сделкам, задачам и заметкам…",
      hint: "Введите не менее %{min} символов для поиска",
      empty: "Ничего не найдено",
      error: "Поиск сейчас недоступен. Попробуйте ещё раз.",
      untitled_result: "(без названия)",
      show_more: "Показать ещё",
      groups: {
        contacts: "Контакты",
        companies: "Компании",
        leads: "Лиды",
        deals: "Сделки",
        tasks: "Задачи",
        contact_notes: "Заметки к контактам",
        deal_notes: "Заметки к сделкам",
      },
    },
    image_editor: {
      change: "Изменить",
      drop_hint: "Перетащите файл сюда или нажмите, чтобы выбрать.",
      editable_content: "Редактируемое содержимое",
      title: "Загрузка и изменение размера изображения",
      update_image: "Обновить изображение",
    },
    import: {
      action: {
        download_error_report: "Скачать отчёт об ошибках",
        import: "Импортировать",
        import_another: "Импортировать другой файл",
      },
      error: {
        unable: "Не удалось импортировать этот файл.",
      },
      idle: {
        description_1:
          "Можно импортировать сотрудников, компании, контакты, заметки и задачи.",
        description_2: "Данные должны быть в файле JSON по следующему образцу:",
      },
      status: {
        all_success: "Все записи импортированы.",
        complete: "Импорт завершён.",
        failed: "Не удалось",
        imported: "Импортировано",
        in_progress: "Идёт импорт, не закрывайте эту страницу.",
        some_failed: "Часть записей не импортирована.",
        table_caption: "Статус импорта",
      },
      title: "Импорт из JSON",
    },
    settings: {
      about: "О программе",
      companies: {
        sectors: "Отрасли",
      },
      dark_mode_logo: "Логотип для тёмной темы",
      deals: {
        categories: "Категории",
        currency: "Валюта",
        pipeline_help: "Выберите стадии, которые считаются сделками в работе.",
        pipeline_statuses: "Стадии «в работе»",
        stages: "Стадии",
      },
      light_mode_logo: "Логотип для светлой темы",
      notes: {
        statuses: "Статусы",
      },
      reset_defaults: "Сбросить настройки",
      save_error: "Не удалось сохранить настройки",
      saved: "Настройки сохранены",
      saving: "Сохраняем…",
      tasks: {
        types: "Типы",
      },
      preferences: "Предпочтения",
      title: "Настройки",
      app_title: "Название приложения",
      timezone: "Часовой пояс компании",
      timezone_hint:
        "По нему CRM считает день: когда задача просрочена и когда отправлять уведомления (с 9:00 до 20:00).",
      sections: {
        branding: "Оформление",
      },
      validation: {
        duplicate: "Повтор (%{display_name}): %{items}",
        in_use:
          "Нельзя удалить (%{display_name}): они используются в сделках: %{items}",
        validating: "Проверяем…",
        entities: {
          categories: "категории",
          stages: "стадии",
        },
      },
    },
    theme: {
      dark: "Тёмная",
      label: "Тема",
      light: "Светлая",
      system: "Как в системе",
    },
    language: "Язык",
    navigation: {
      label: "Навигация CRM",
      leads: "Лиды",
      clients: "Клиенты",
      today: "Сегодня",
    },
    profile: {
      add_secondary_email: "Добавить адрес почты",
      email_taken: "%{email} уже используется другим сотрудником",
      no_secondary_emails: "Нет",
      secondary_email_invalid: "%{email} — неверный адрес почты",
      secondary_email_is_primary: "%{email} уже ваш основной адрес",
      secondary_email_taken: "%{email} уже используется другим сотрудником",
      too_many_secondary_emails:
        "Можно добавить не более 10 дополнительных адресов",
      secondary_emails_help:
        "Другие адреса, с которых вы отправляете письма. Очистите поле, чтобы удалить адрес.",
      inbound: {
        description:
          "Можно отправлять письма на входящий адрес вашего сервера, например добавив его в поле «%{field}». «Всё видно» обработает письма и добавит заметки к нужным контактам.",
        title: "Входящая почта",
      },
      mcp: {
        title: "MCP-сервер",
        description:
          "Используйте этот адрес, чтобы подключить ИИ-ассистента к данным CRM по протоколу MCP.",
      },
      password: {
        change: "Сменить пароль",
        current: "Текущий пароль",
        new: "Новый пароль",
        changed: "Пароль изменён",
      },
      password_reset_sent: "Письмо для сброса пароля отправлено на вашу почту",
      record_not_found: "Запись не найдена",
      title: "Профиль",
      updated: "Профиль обновлён",
      update_error: "Произошла ошибка. Попробуйте ещё раз",
    },
    validation: {
      invalid_url: "Нужна корректная ссылка",
      invalid_linkedin_url: "Ссылка должна вести на linkedin.com",
    },
  },
};
